var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18696_44133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18696_44133)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "#EF0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18696_44133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18696_44133)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V14H18V0H0Z",
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72982 10.8104L7.24816 12.6589L6.88927 10.3172L4.68185 11.1772L5.54188 8.9698L3.2002 8.6109L5.04871 7.12924L3.2002 5.64758L5.54188 5.28868L4.68185 3.08127L6.88927 3.9413L7.24816 1.59961L8.72982 3.44812L10.2115 1.59961L10.5704 3.9413L12.7778 3.08127L11.9178 5.28868L14.2595 5.64758L12.4109 7.12924L14.2595 8.6109L11.9178 8.9698L12.7778 11.1772L10.5704 10.3172L10.2115 12.6589L8.72982 10.8104ZM8.72982 9.99158C10.3107 9.99158 11.5922 8.71007 11.5922 7.12924C11.5922 5.54841 10.3107 4.26689 8.72982 4.26689C7.14899 4.26689 5.86748 5.54841 5.86748 7.12924C5.86748 8.71007 7.14899 9.99158 8.72982 9.99158ZM11.0197 7.12924C11.0197 8.3939 9.99449 9.41912 8.72982 9.41912C7.46516 9.41912 6.43995 8.3939 6.43995 7.12924C6.43995 5.86457 7.46516 4.83936 8.72982 4.83936C9.99449 4.83936 11.0197 5.86457 11.0197 7.12924Z",
    fill: "#FEFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhTw);
export default __webpack_public_path__ + "static/media/zh-TW.39042bbdc245cfe9cec505cb1f2cb5d6.svg";
export { ForwardRef as ReactComponent };